(() => {
  const preferenceButtonSelector = '[data-hydros-cookie-preferences]';
  const printButtonSelector = '[data-hydros-print]';

  if (document.querySelector('.hydros-legal')) {
    document.title = 'Informations légales – Hydros';
  }

  document.addEventListener('click', (event) => {
    const preferenceButton = event.target.closest(preferenceButtonSelector);
    if (preferenceButton) {
      const nativePreferenceButton = document.querySelector('#shopify-pc__banner__btn-manage-prefs');
      if (nativePreferenceButton) {
        nativePreferenceButton.click();
      } else if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
        window.privacyBanner.showPreferences();
      } else {
        window.location.href = preferenceButton.dataset.fallbackUrl || '/policies/privacy-policy';
      }
      return;
    }

    const printButton = event.target.closest(printButtonSelector);
    if (!printButton) return;

    document.body.classList.add('hydros-print-withdrawal');
    window.print();
    window.setTimeout(() => document.body.classList.remove('hydros-print-withdrawal'), 250);
  });

  window.addEventListener('afterprint', () => {
    document.body.classList.remove('hydros-print-withdrawal');
  });
})();
